module.exports = {
  siteTitle: 'Programa FMVng 2018',
  siteShortName: 'FMVNG18', // Site title.
  siteTitleAlt: 'Programa FM Vilanova 2018', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://fmvng.app', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription:
    "Aplicació web progressiva amb tot el programa d'activitats de la Festa Major de Vilanova i la Geltrú", // Website description used for RSS feeds/meta description tag.
  keywords: [
    'Festa Major',
    'Vilanova i la Geltrú',
    'Programa de Festa Major',
    'Cultural popular',
    'Tradicions',
    'Vilanova',
    'FMVng',
  ], // Copyright string for the footer of the website and RSS feed.
  themeColor: '#FFA000',
  backgroundColor: '#fff',
  googleAnalytics: 'UA-121776060-2',
}
